









import { Component, Vue } from 'vue-property-decorator'
import jwt_decode from 'jwt-decode'
import ResetPassword from '@/components/ResetPassword.vue'
import router from '../router'

@Component({
  components: {
    ResetPassword
  }
})
export default class Verify extends Vue {
  verified: boolean = false

  mounted() {
    try {
      const decoded: any = jwt_decode(this.$route.params.code)
      if (decoded.aud !== 'verification' || decoded.exp <= Date.now()/1000) {
        throw 'invalid'
      }
      else {
        this.verified = true
      }
    }
    catch {
      this.$error({
        title: 'Invalid or Expired Request',
        content: 'Please re-check your request',
        onOk() {
          router.push({name: 'Login'})
        }
      })
    }
  }
}
